import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import Init from './init';
import setClientSize from '../../../shared/actions/setClientSize';
import fetchEnhancements, { receivedToken } from '../../../shared/actions/fetchEnhancements';
import { attachHotkeyInterceptors } from '../../../shared/actions/find';
import loadPdf, { loadOutline } from '../../../shared/actions/loadPdf';

const mapStateToProps = () => ({});

function mapDispatchToProps(dispatch) {
  return {
    attachHotkeyInterceptors: () => dispatch(attachHotkeyInterceptors()),
    getEnhancements: () => dispatch(fetchEnhancements()),
    setClientSize: () => dispatch(setClientSize()),
    loadOutline: pdfDocument => loadOutline(pdfDocument, dispatch),
    loadPdf: () => dispatch(loadPdf()),
    receivedToken: token => dispatch(receivedToken(token)),
    attachResizeListener: () => {
      window.addEventListener(
        'resize',
        debounce(() => dispatch(setClientSize()), 50),
      );
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Init);
